module.exports = __webpack_public_path__ + "static/media/cream soda_elephant house.9d8045a8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/cream soda_elephant house.gif
// module id = 387
// module chunks = 0